"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var parameters = {
    defaultStartingHour: "08:00:00",
    defaultPointOfInterestMinutesDuration: 60
};
exports.default = parameters;
